/* @ngInject */

export default function($window, $templateCache) {
	let $next, $prev, $element, $li, $win, $menu, scrollWidth, animDuration, winWidth;

	let template = $templateCache.get('scrollable/scrollable-menu-tmpl.html');

	return {
		template,
		restrict: 'A',
		transclude: true,
		link: ScrollableMenuLink
	};

	function init() {
		$win = $($window);
		$next = $('.next', $element);
		$prev = $('.prev', $element);
		$li = $('li:first-child', $element);
		$menu = $('ul:first-child', $element);

		animDuration = 600;
		winWidth = $win.width();
		scrollWidth = $li.outerWidth(true) * 1.15;

		if (winWidth > 521) {
			showStretched(60);
			return;
		}

		setHandlersPosition();
	}

	function ScrollableMenuLink(scope, element, attrs) {
		$element = $(element);

		init();

		$win.on('resize', () => {
			winWidth = $win.width();
			if (winWidth > 521) {
				showStretched();
				return;
			}
			setHandlersPosition();
		});

		$prev.on('click', (evt) => {
			evt.preventDefault();
			scroll(-1);
		});

		$next.on('click', (evt) => {
			evt.preventDefault();
			scroll(1);
		});
	}

	function scroll(direction, length) {
		let steps,
			currentSteps = $menu.scrollLeft();
		if (length) {
			steps = length;
		} else if (direction === -1) {
			if (currentSteps === 0) {
				return;
			}
			steps = currentSteps - scrollWidth;
		} else {
			steps = currentSteps + scrollWidth;
		}

		$menu.animate({ scrollLeft: steps }, animDuration);
	}

	function showStretched() {
		setScrollableSize(60);
		hideArrows();
	}

	function setHandlersPosition() {
		let top = 0;
		showArrow();

		$next.css('left', `${winWidth - 77.5}px`);
		$next.css('height', `${$li.outerHeight(true)}px`);

		$prev.css('top', `${top}em`);
		$prev.css('height', `${$li.outerHeight(true)}px`);

		setScrollableSize();
	}

	function setScrollableSize(size) {
		let offsetTag = $('burger-menu .hamburger');
		let offset = offsetTag.length > 0 ? offsetTag.outerWidth() : 0;
		let scrollableWidth = size || winWidth - offset;

		$menu.width(scrollableWidth);
	}

	function showArrow() {
		$next.css('display', 'inline');
		$prev.css('display', 'inline');
	}
	function hideArrows() {
		$next.css('display', 'none');
		$prev.css('display', 'none');
	}
}
